import { FC } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import TestDriveInvitationPage from './pages/TestDriveInvitationPage'
import DeliveryServiceInvitationPage from './pages/DeliveryServiceInvitationPage'
import DealerSelectionPage from './pages/DealerSelectionPage'
import ReceiptViewPage from './pages/ReceiptViewPage'
import UserEditPage from './pages/UserEditPage'
import ProtectedRoute from './components/ProtectedRoute'
import './App.css'

/** 根路径带 ?code= 时保留查询串，否则重定向会丢掉 OAuth 参数 */
const RootRedirect: FC = () => {
  const { search } = useLocation()
  return <Navigate to={`/dashboard${search}`} replace />
}

const FallbackRedirect: FC = () => {
  const { search } = useLocation()
  return <Navigate to={`/dashboard${search}`} replace />
}

const App: FC = () => {
  return (
    <div className="mobile-app">
      <Routes>
        {/* 登录页面 - 不需要认证 */}
        <Route 
          path="/login" 
          element={
            <ProtectedRoute requireAuth={false}>
              <LoginPage />
            </ProtectedRoute>
          } 
        />
        
        {/* 仪表盘页面 - 需要认证 */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute requireAuth={true}>
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        
                {/* 试乘试驾邀请函页面 - 需要认证 */}
                <Route 
                  path="/test-drive-invitation" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <TestDriveInvitationPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* 交车服务邀请函页面 - 需要认证 */}
                <Route 
                  path="/delivery-service-invitation" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <DeliveryServiceInvitationPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* 经销商选择页面 - 需要认证 */}
                <Route 
                  path="/dealer-selection" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <DealerSelectionPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* 回执查看页面 - 需要认证 */}
                <Route 
                  path="/receipt-view" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <ReceiptViewPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* 用户信息编辑页面 - 需要认证 */}
                <Route 
                  path="/user-edit" 
                  element={
                    <ProtectedRoute requireAuth={true}>
                      <UserEditPage />
                    </ProtectedRoute>
                  } 
                />
        
        
        {/* 根路径重定向 */}
        <Route path="/" element={<RootRedirect />} />
        
        {/* 其他未匹配路径重定向到仪表盘 */}
        <Route path="*" element={<FallbackRedirect />} />
      </Routes>
    </div>
  )
}

export default App
